import React from "react"
import PropTypes from "prop-types"
import { Flex, Checkbox } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import styles from "../index.module.css"

/**
 * DaySelector component for selecting days of the week with checkboxes
 */
const DaySelector = ({ selectedDay, selectedDays, onDayClick, onDayToggle }) => {
  const { t } = useTranslation()

  const days = [
    { key: "sun", label: t("crewMember.availability.days.sun") },
    { key: "mon", label: t("crewMember.availability.days.mon") },
    { key: "tue", label: t("crewMember.availability.days.tue") },
    { key: "wed", label: t("crewMember.availability.days.wed") },
    { key: "thu", label: t("crewMember.availability.days.thu") },
    { key: "fri", label: t("crewMember.availability.days.fri") },
    { key: "sat", label: t("crewMember.availability.days.sat") }
  ]

  const handleDayButtonClick = (dayKey) => {
    // Set as selected day for viewing
    onDayClick(dayKey)

    // Toggle the checkbox
    const isCurrentlyChecked = selectedDays.includes(dayKey)
    onDayToggle(dayKey, !isCurrentlyChecked)
  }

  return (
    <Flex vertical gap={16} className="overflow-auto">
      {/* Day Buttons */}
      <Flex gap={8} className={styles.dayButtons} style={{ minWidth: 400 }}>
        {days.map((day) => (
          <div key={day.key} className={styles.dayButtonWrapper}>
            <button
              type="button"
              onClick={() => handleDayButtonClick(day.key)}
              className={`${styles.dayButton} ${selectedDay === day.key ? styles.dayButtonActive : ""}`}
            >
              <Text>{day.label}</Text>
            </button>
          </div>
        ))}
      </Flex>

      {/* Day Checkboxes */}
      <Flex gap={8} className={styles.dayCheckboxes} style={{ minWidth: 400 }}>
        {days.map((day) => (
          <div key={day.key} className={styles.dayCheckboxWrapper}>
            <Checkbox
              checked={selectedDays.includes(day.key)}
              onChange={(e) => onDayToggle(day.key, e.target.checked)}
              className={styles.dayCheckbox}
            />
          </div>
        ))}
      </Flex>
    </Flex>
  )
}

DaySelector.propTypes = {
  selectedDay: PropTypes.string,
  selectedDays: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDayClick: PropTypes.func.isRequired,
  onDayToggle: PropTypes.func.isRequired
}

export default DaySelector
